import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Select from 'react-select'
import CsvDownloader from 'react-csv-downloader';

import Header from '../../components/header/Header';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';

import { optionalParam, buildParams, formatDate, arrayParamBuilder } from '../../utilities/Generic.js'

import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

class ExportsRevenue extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
  }

  state = {
    date_from: null,
    date_to: null,
    location: "",
    tag_ids: [],
    role_id: "",

    refresh_date_from: formatDate(this.previousMonday()),
    refresh_date_to: formatDate(this.nextSunday()),
    refresh_location: "",
    refresh_tag_ids: [],
    refresh_role_id: "",

    locations: [],
    roles: [],
    tags: [],
    people: [],

    locationsLoaded: false,
    tagsLoaded: false,
    rolesLoaded: false,
    revenueLoaded: false,
    unauthorized: "",
    error: ""
  };

  previousMonday(){
    const today = new Date();
    const day = today.getDay();
    const diff = (day + 6) % 7;
    const lastMonday = new Date(today);
    lastMonday.setDate(today.getDate() - diff);
    return lastMonday;
  }

  nextSunday(){
    const today = new Date();
    const day = today.getDay();
    const diff = (7 - day) % 7;
    const nextSunday = new Date(today);
    nextSunday.setDate(today.getDate() + diff);
    return nextSunday;
  }
  
  fetchData() {
    const params = `revenue[date_from]=${this.state.date_from}&revenue[date_to]=${this.state.date_to}&revenue[location]=${this.state.location}&revenue[role_id]=${this.state.role_id}${arrayParamBuilder("revenue", "tag_ids", this.state.tag_ids)}`;

    request('GET', `/v1/a/exports/revenue?${params}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, revenueLoaded: true });
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, revenueLoaded: true })
      })
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    let url = {
      date_from: this.state.date_from,
      date_to: this.state.date_to,
      location: this.state.location,
      tag_ids: this.state.tag_ids,
      role_id: this.state.role_id
    }

    url[name] = value
    const params = buildParams(
      `from=${url.date_from}&to=${url.date_to}`,
      optionalParam("location", url.location),
      optionalParam("tag_ids", url.tag_ids),
      optionalParam("role_id", url.role_id)
    )
    
    this.props.history.push(`/exports/revenue?${params}`);
  }

  handleMultiSelectChange(data) {
    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = "tag_ids"
    fakeEvent.target.value = data.map(option => option.value);

    this.handleChange(fakeEvent)
  }

  shiftWeek(direction) {
    const { date_from } = this.state;

    const newFrom = new Date(date_from);
    newFrom.setDate(newFrom.getDate() + 7 * direction);

    const newTo = new Date(newFrom);
    newTo.setDate(newFrom.getDate() + 6);

    let url = {
      date_from: formatDate(newFrom),
      date_to: formatDate(newTo),
      location: this.state.location,
      tag_ids: this.state.tag_ids,
      role_id: this.state.role_id
    }

    const params = buildParams(
      `from=${url.date_from}&to=${url.date_to}`,
      optionalParam("location", url.location),
      optionalParam("tag_ids", url.tag_ids),
      optionalParam("role_id", url.role_id)
    )

    this.props.history.push(`/exports/revenue?${params}`);
  }

  render() {
    const { date_from, date_to, people, location, locations, locationsLoaded, tag_ids, tags, tagsLoaded, unauthorized, error, rolesLoaded, revenueLoaded, role_id, roles } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (locationsLoaded === false || tagsLoaded === false || rolesLoaded === false) {
      return (
        <div>
          <SetTitle title={"Export Revenue | Exports"} />
          <Header />

          <div className="main-page">
            <h2 className="page-title">Export Revenue</h2>
            <OrganisationName />

            <p>Loading ...</p>
          </div>
        </div>
      )
    }

    const selectOptions = tags.map(tag => ({ value: tag.id, label: tag.name }))
    const selectedTags = selectOptions.filter(option => tag_ids.includes(option.value))

    return (
      <div>
        <SetTitle title={"Export Revenue | Exports"} />
        <Header />

        <div className="main-page">
          <h2 className="page-title">Export Revenue</h2>
          <OrganisationName />

          <div className="export-selection">
            <div className="week-buttons">
              <div className="button" onClick={() => this.shiftWeek(-1)}>Previous Week</div>
              <div className="button" onClick={() => this.shiftWeek(1)}>Next Week</div>
            </div>

            <div className="selection-block">
              <label className="column">Date from:</label>
              <input className="column" type="date" name="date_from" value={date_from} onChange={this.handleChange} />
            </div>

            <div className="selection-block">
              <label className="column">Date to:</label>
              <input className="column" type="date" name="date_to" value={date_to} onChange={this.handleChange} />
            </div>

            <div className="selection-block">
              <label className="column">Location:</label>
              <select name="location" value={location} onChange={this.handleChange} data-testid="select-locations">
                <option value="">All</option>
                {locations.map((location) => (
                  <option value={location.id} key={location.id}>{location.name}</option>
                ))}
              </select>
            </div>

            <div className="selection-block">
              <label className="column">Roles:</label>
              <select name="role_id" value={role_id} onChange={this.handleChange}>
                <option value="">All</option>
                {roles.map((role) => (
                  <option value={role.id} key={role.id}>{role.name}</option>
                ))}               
              </select>
            </div>

            <div className="selection-block">
              <label className="column">Filter by Tags:</label>
              <Select onChange={this.handleMultiSelectChange} options={selectOptions} value={selectedTags} isMulti={true} unstyled={true} className="react-select" classNamePrefix="react-select" placeholder={"All"} />
            </div>
          </div>

          {revenueLoaded ? (
            <div className="widgets">
              {this.renderDownloadCSV(people)}
              {people.map((person, index) => (
                this.renderPersonSection(person, index)
              ))}

              {people.length === 0 && (
                <p>No data found for those filters.</p>
              )}
            </div>
            ) : (
            <p>Loading ...</p>
          )}
        </div>
      </div>
    );
  }

  renderDownloadCSV(people) {
    let filename = `revenue-export-${this.state.date_from}-to-${this.state.date_to}.csv`
    let formatted_sales = [];

    people.forEach(person => {
      const personSales = person.sales.map(sale => ({
        staff: person.full_name,
        ...sale,
        clients: sale.clients.map(client => client.name).join(', '),
        service_price: sale.service_price,
        deposit: sale.deposit,
        paid: sale.paid
      }))
      formatted_sales.push(...personSales);
    })

    let columns = [
      { displayname: "Staff", id: "staff" },
      { displayname: "Date", id: "date" },
      { displayname: "Time", id: "time" },
      { displayname: "Clients", id: "clients" },
      { displayname: "Service Name", id: "service_name" },
      { displayname: "Service Price", id: "service_price" },
      { displayname: "Deposit", id: "deposit" },
      { displayname: "Paid", id: "paid" },
    ];

    return (
      <CsvDownloader datas={formatted_sales} columns={columns} filename={filename} className="edit-button download-csv relative-csv right" wrapColumnChar='"'>
        <div>
          <FontAwesomeIcon icon={faFileDownload} />
          <h4>Download CSV</h4>
        </div>
      </CsvDownloader>
    )
  }

  renderPersonSection(person, index) {
    const totalRevenue = person.sales.reduce((total, sale) => {
      const saleRevenue = parseFloat(sale.paid.replace('£', ''));
      return total + saleRevenue;
    }, 0);

    const groupedSales = Object.groupBy(person.sales, (sale) => sale.date);

    return (
      <React.Fragment key={index}>
        <h3 className="no-bottom-margin top-padding">{person.full_name}</h3>
        <div className="small-top-padding">Total revenue: {`£${totalRevenue.toFixed(2)}`}</div>

        <table className="table big-table bottom-margin" data-testid="table">
          <thead>
            <tr className="tr heading">
              <th className="th">Date</th>
              <th className="th">Time</th>
              <th className="th">Clients</th>
              <th className="th">Service Name</th>
              <th className="th">Price</th>
              <th className="th">Deposit</th>
              <th className="th">Paid</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(groupedSales).map(([date, salesForDate]) =>
              salesForDate.map((sale, index) =>
                this.renderPersonSales(sale, index, salesForDate.length)
              )
            )}
          </tbody>
        </table>
      </React.Fragment>
    )
  }

  renderPersonSales(sale, index, dateGroupLength) {
    return (
      <tr className="tr" key={index}>
        {index === 0 && (
          <td className="td" rowSpan={dateGroupLength}>
            {sale.date}
          </td>
        )}
        <td className="td">{sale.time}</td>
        <td className="td">{sale.clients.map(client => client.name).join(', ')}</td>
        <td className="td">{sale.service_name}</td>
        <td className="td">{sale.service_price}</td>
        <td className="td">{sale.deposit}</td>
        <td className="td">{sale.paid}</td>
      </tr>
    )
  }

  syncParamsAndState() {
    const params = new URLSearchParams(this.props.location.search);

    const date_from = params.get('from') || this.state.refresh_date_from;
    const date_to = params.get('to') || this.state.refresh_date_to;
    const location = params.get('location') || this.state.refresh_location;
    const tag_ids = params.get('tag_ids')?.split(",").map(id => parseInt(id)) || this.state.refresh_tag_ids;
    const role_id = params.get('role_id') || this.state.refresh_role_id;

    const builtParams = buildParams(
      `from=${date_from}&to=${date_to}`,
      optionalParam("location", location),
      optionalParam("tag_ids", tag_ids),
      optionalParam("role_id", role_id)
    );

    const currentParams = this.props.location.search.replace("?", "");

    if (currentParams !== builtParams) {
      this.props.history.replace(`/exports/revenue?${builtParams}`);
      return;
    }

    this.setState({
      date_from: date_from,
      date_to: date_to,
      location: location,
      tag_ids: tag_ids,
      role_id: role_id,
      revenueLoaded: false
    }, () => {
      this.fetchData();
    });
  }

  componentDidMount() {
    this.syncParamsAndState();

    // normal API fetching stuff
    request('GET', `/v1/a/locations/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ locations: data, locationsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, locationsLoaded: true })
      })

    request('GET', `/v1/a/tags/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ tags: data, tagsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, tagsLoaded: true })
      })

    request('GET', `/v1/a/roles/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ roles: data, rolesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, rolesLoaded: true })
      })
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.syncParamsAndState();
    }
  }
}

export default ExportsRevenue;
